import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

export interface No3Cn56ResetBlockParams {
  sendingPpo: string;
  receivingPpo: string;
  year: number;
  accountingType: string;
  mailCategory: string;
}

interface UseNo3Cn56ResetBlockOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

/**
 * Hook for resetting NO3 & CN56 bilateral blocks
 * @param options Configuration options for the mutation
 * @returns Mutation object for resetting blocks
 */
export function useNo3Cn56ResetBlock(options: UseNo3Cn56ResetBlockOptions = {}) {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: async (params: No3Cn56ResetBlockParams) => {
      const response = await axios.delete('/no3-cn56-bilateral/by-report', {
        params: {
          sendingPpo: params.sendingPpo,
          receivingPpo: params.receivingPpo,
          year: params.year,
          accountingType: params.accountingType,
          mailCategory: params.mailCategory,
        }
      });
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate related queries to trigger refetch
      queryClient.invalidateQueries({ queryKey: ['no3-cn56-summary'] });
      queryClient.invalidateQueries({ queryKey: ['ipc-td-accounting'] });
      
      // Call the onSuccess callback if provided
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },
    onError: (error) => {
      // Call the onError callback if provided
      if (options.onError) {
        options.onError(error);
      }
    }
  });
} 